import { render, staticRenderFns } from "./a-order-prices.vue?vue&type=template&id=f81491a2&scoped=true&"
import script from "./a-order-prices.vue?vue&type=script&lang=js&"
export * from "./a-order-prices.vue?vue&type=script&lang=js&"
import style0 from "./a-order-prices.vue?vue&type=style&index=0&id=f81491a2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f81491a2",
  null
  
)

export default component.exports